import { render, staticRenderFns } from "./WorkCalendar.vue?vue&type=template&id=64ac9faa&scoped=true"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendar.vue?vue&type=style&index=0&id=64ac9faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac9faa",
  null
  
)

export default component.exports